'use strict';
  
angular.module('buyersService')
.factory('BuyerService', ['appInfo', '$log', '$rootScope' ,'$http', '$q', 'CacheFactory', 'CommonService', '$filter', 'localstorage',
    function (appInfo, $log, $rootScope, $http, $q, CacheFactory, CommonService, $filter, localstorage) {
        var service = {}
        , currentUser = $rootScope.currentUser
        , usercode    = $rootScope.currentUser.authdata
        , activeAgency = $rootScope.currentUser.activeAgency;
        
        var fnRefreshVars = function() {
            currentUser = $rootScope.currentUser;
            usercode    = $rootScope.currentUser.authdata;
            activeAgency = $rootScope.currentUser.activeAgency;
        }
        
        $rootScope.totalSearch = 0;

        service.getPropertyTypes = function() {
          return [
              {id: "10", name: "House", selected: false},
              {id: "12", name: "Townhouse / Duplex / Villa", selected: false},
              {id: "11", name: "Apartment / Unit" , selected: false},
              {id: "13", name: "Land", selected: false}
          ];
        };

        // Add new or Update to do item
        service.savePreferences = function(preference) {
            fnRefreshVars();
            preference.usercode = currentUser.authdata;
            preference.contactId = currentUser.id;
            preference.organisationId = activeAgency.id;
            var dfd = $q.defer();
            $http({
                    url: appInfo.endpoint+'buyers/setPreferences.json', 
                    method: "POST",
                    params: { api_key: appInfo.key },
                    data: preference
                }).success(function(data) {
                    dfd.resolve(data);
                }).error(function(data, status, headers, config) {
                    dfd.reject("Error: request returned status " + status); 
                });

            return dfd.promise;
        };
        
        service.getPreferences = function () {
            fnRefreshVars();
            var dfd = $q.defer();
            $http({
                url: appInfo.endpoint+'buyers/preferences.json', 
                method: "GET",
                params: {usercode: usercode, api_key: appInfo.key, contactId: currentUser.id, organisationId: activeAgency.id},
            }).success(function (data, status, headers, config){
                dfd.resolve(data);
            }).error(function(data, status, headers, config) {
                dfd.reject("Error: Unable to update. Status = " + status); 
            });

            return dfd.promise;   
        };

        service.getUpcomingOpenHomes = function() {
            fnRefreshVars();
            var dfd = $q.defer();
            $http({
                url: appInfo.endpoint+'buyers/openhomes.json', 
                method: "GET",
                params: {usercode: usercode, api_key: appInfo.key, orgId: activeAgency.id},
                transformResponse: function (data, headers) {
                var openHomes = [];
                var response = JSON.parse(data);
                angular.forEach(response, function(rs){
                  var ohStart = parseInt(rs.starts);
                  var currentTime = parseInt((new Date()).getTime()/1000);

                  //only future open homes needs to be displayed
                  if(ohStart > currentTime) {
                    var listings = [];
                    angular.forEach(rs.property, function(prop){
                      prop.propertyRef = prop.propertyId*12569;
                      prop.bed = 0;
                      prop.bath = 0;
                      prop.parking =0;
                      angular.forEach(prop.propertyComponents[0], function(comp) {
                        if(comp.name=="Bedroom") {
                          prop.bed = parseInt(comp.qty);
                        } else if(comp.name=="Bathroom"){
                          prop.bath= parseInt(comp.qty);
                        } else if(comp.name=="Parking"){
                          prop.parking = parseInt(comp.qty);
                        }
                      });
                      listings.push(prop);
                    });
                    rs.property = listings;
                    openHomes.push(rs);
                  }
                  
                });
                return openHomes;
              },
            }).success(function (data, status, headers, config){
                dfd.resolve(data);
            }).error(function(data, status, headers, config) {
                dfd.reject("Error: Unable to update. Status = " + status); 
            });
            return dfd.promise;   
        }

        var getRelatedIdentifiers = function(identifier) {
           var arrIdentifier = [
            ['heritage', 'charmhaven', 'wyong', 'lakemunmorah'],
            ['hawkesbury', 'penrith'],
            ['baulkhamhills', 'rousehill'],
            ['tumbiumbi', 'berkeleyvale',  'theentrance']
           ];
           for(i=0; i< arrIdentifier.length; i++) {
              if(arrIdentifier[i].indexOf(identifier.toLowerCase()) > -1) {
                return arrIdentifier[i];
                break;
              }
           }
           if(identifier == 'headoffice') {
              return ['headoffice','coastal', 'charmhaven', 'tumbiumbi', 'wyong',  'theentrance', 'taree', 'forster', 'hawkesbury', 'penrith', 'baulkhamhills', 'rousehill'];
              //return ['headoffice'];
           }
           return [identifier];
        }
        

        service.getPreferedProperties = function(preferences, start) {
            fnRefreshVars();
            var identifier = activeAgency.identifier;
            // var identifier ="hawkesbury";
            // var identifier ="Coastal";
            var dfd = $q.defer();
            var agentId = $rootScope.currentUser.id;
            var priceRange = [ { from: preferences.priceFrom }, { to: (preferences.priceTo>0)?preferences.priceTo:999999999 } ];
            var propertyComponents = [];
            var filters = [];

            // "propertyComponents": {
            //     "components": [
            //       {"measure":"yes", "name":"pool", "qty": "1"},
            //       {"measure":"", "name":"bed", "qty": "1"}
            //     ],
            //     "matchType": "AND"
            // }
            if(preferences.bed !='' && preferences.bed!="0"){
              propertyComponents.push({ qty: preferences.bed, name: 'bed'});
            }
            if(preferences.bath !='' && preferences.bath!="0"){
              propertyComponents.push({ qty: preferences.bath, name: 'bath'});
            }
            if(preferences.parking !='' && preferences.parking!="0"){
              propertyComponents.push({ qty: preferences.parking, name: 'parking'});
            }
            if(preferences.pool !='' && preferences.pool!="0"){
              propertyComponents.push({ measure: preferences.pool, name: 'pool'});
            }
            
            if(propertyComponents.length>0) {
              filters.push({propertyComponents: { components: propertyComponents, matchType: 'AND',qtyCompareType:'>=' }})
            }
         
            // {"filters": [{"agency": ["hawkesbury"]}, {"price": [{"from": "780000"}, {"to": "860000"}]},
            // {"state": [10, 20]}]}
            if(preferences.suburbs.length>0) {
               var suburbs = [];
               for(var i=0; i<preferences.suburbs.length; i++) {
                  if(preferences.suburbs[i].id !='' && preferences.suburbs[i].id != '0') {
                      suburbs.push(preferences.suburbs[i].id);    
                  }
                }
                if(suburbs.length>0) {
                  filters.push({'suburb': suburbs});  
                }
            }

            if(preferences.propertyTypes.length>0) {
              var propertyTypes = service.getPropertyTypes();
              var propertyTypeNames = [];

              for(var i=0; i<preferences.propertyTypes.length; i++) {
                var index = CommonService.indexById(propertyTypes, preferences.propertyTypes[i]);
                if(index>-1) {
                    propertyTypeNames.push(propertyTypes[index].name);    
                }
              }
              if(propertyTypeNames.length) {
                filters.push({'propertyTypes': propertyTypeNames});    
              }
              
            }
            var arrIdentifier = getRelatedIdentifiers(identifier);
            filters.push({'agency': arrIdentifier});
            filters.push({'price': priceRange});
            filters.push({'state': [10, 20]});
            filters.push({'postCounts': "1"});
            filters.push({'nearByKM': "15"});

            var dataParams = {
              'filters': filters,
              'pagination': {'start': start, 'limit' : 10}
            };
            $http({
              url: appInfo.endpoint +'listing/search.json',
              method: "POST",
              params: {api_key: appInfo.key},
              data: dataParams,
              transformResponse: function (data, headers) {
                var listings = [];
                var response = JSON.parse(data);
                
                $rootScope.totalSearch =response.pagination.total;

                angular.forEach(response.properties, function(rs){
                  var prop = rs;

                  //filter out past open homes
                  if(prop.openHome && prop.openHome.length >0) {
                    var futureOpenHomes = [];
                    var openHomes = prop.openHome[0];
                    var currentDate = parseInt(new Date().getTime()/1000);
                    angular.forEach(openHomes, function(openHome){
                        if( parseInt(openHome.starts) > currentDate) {
                          futureOpenHomes.push(openHome);  
                        }
                    });
                    prop.openHome[0] = futureOpenHomes;
                  }

                  prop.propertyRef = rs.propertyId*12569;
                 
                  prop.bed = 0;
                  prop.bath = 0;
                  prop.parking =0;
                  angular.forEach(prop.propertyComponents[0], function(comp) {
                    if(comp.name=="Bedroom") {
                      prop.bed = parseInt(comp.qty);
                    } else if(comp.name=="Bathroom") {
                      prop.bath= parseInt(comp.qty);
                    } else if(comp.name=="Parking"){
                      prop.parking= parseInt(comp.qty);
                    }
                  });
                  listings.push(prop);

                });
                return listings;
              },
            }).success(function(data, status, headers, config) {
              dfd.resolve(data);
            }).error(function(data, status, headers, config) {
              dfd.reject("Error: request returned status " + status);
            });
            return dfd.promise;
        };
        
        service.addToWatchlist = function(propertyId) {
          fnRefreshVars();
          var watchlist = { 
            contactId: currentUser.id, 
            organisationId: activeAgency.id, 
            propertyId: propertyId,
            usercode: usercode
          };
            
          var dfd = $q.defer();
          $http({
              url: appInfo.endpoint+'buyers/addPropertyToWatchlist.json', 
              method: "POST",
              params: { api_key: appInfo.key },
              data: watchlist
          }).success(function(data) {
              dfd.resolve(data);
          }).error(function(data, status, headers, config) {
              dfd.reject("Error: request returned status " + status); 
          });

          return dfd.promise;
        }

        service.removeFromWatchlist = function(watchlistId) {
          fnRefreshVars();
          var dfd = $q.defer();
          $http({
              url: appInfo.endpoint+'buyers/removePropertyFromWatchList.json', 
              method: "POST",
              params: { api_key: appInfo.key },
              data: { id: watchlistId, usercode: usercode }
          }).success(function(data) {
              dfd.resolve(data);
          }).error(function(data, status, headers, config) {
              dfd.reject("Error: request returned status " + status); 
          });

          return dfd.promise;
        }

        
        service.getWatchlist = function () {
            fnRefreshVars();
            var dfd = $q.defer();
            $http({
                url: appInfo.endpoint+'buyers/propertywatchlist.json', 
                method: "GET",
                params: {usercode: usercode, api_key: appInfo.key},
                transformResponse: function (data, headers) {
                
                  var watchlist = JSON.parse(data);
                  angular.forEach(watchlist, function(rs) {
                    if (rs.property.length) {
                      rs.property = rs.property[0];
                      var prop = rs.property;

                      //filter out past open homes
                      if(prop.openHome && prop.openHome.length >0) {
                        var futureOpenHomes = [];
                        var openHomes = prop.openHome[0];
                        var currentDate = parseInt(new Date().getTime()/1000);
                        angular.forEach(openHomes, function(openHome){
                            if( parseInt(openHome.starts) > currentDate) {
                              futureOpenHomes.push(openHome);  
                            }
                        });
                        prop.openHome[0] = futureOpenHomes;
                      }
                  

                      prop.propertyRef = prop.propertyId*12569;
                      prop.bed = 0;
                      prop.bath = 0;
                      prop.parking =0;

                      angular.forEach(prop.propertyComponents[0], function(comp) {
                        if(comp.name == "Bedroom") {
                          prop.bed = parseInt(comp.qty);
                        } else if(comp.name == "Bathroom") {
                          prop.bath= parseInt(comp.qty);
                        } else if(comp.name == "Parking"){
                          prop.parking= parseInt(comp.qty);
                        }
                      });
                    }
                  });
                  return watchlist;
                },
            }).success(function (data, status, headers, config){
                dfd.resolve(data);
            }).error(function(data, status, headers, config) {
                dfd.reject("Error: Unable to update. Status = " + status); 
            });

            return dfd.promise;   
        };

        service.sendFinanceApplicationEmail = function(financeApplicationEmail, property) {
            var toEmail = property.listingAgent[0][0].email;
            var toEmailLeader = property.agency[0].info.email;
            financeApplicationEmail.propertyId = property.propertyId;
            var toEmail = [toEmail, toEmailLeader, 'developer@wiseberry.com.au'];
            // var toEmail = ['anjanshakya@wiseberry.com.au'];
            var emailDetails = {
              toEmail: toEmail,
              sourceEmail: 'no-reply@wiseberry.com.au',
              htmlBody: getFinanceApplicationEmailBody(financeApplicationEmail),
              txtBody: getFinanceApplicationEmailBody(financeApplicationEmail),
              subject: 'Finance Application Request',
              replyToAddress: 'no-reply@wiseberry.com.au'
            };
            return CommonService.sendEmail(emailDetails);
        }

        var getFinanceApplicationEmailBody = function(financeApplicationEmail) {
            var bodyHTML = '<p>Hi,</p>' +
                '<p>There is a new  finance application request from buyer: </p>'  + 
                '<br>' +
                '<hr>' +
                '<p>Details:</p>'+
                '<ul>' +
                '<li>Property:<a href="http://www.wiseberry.com.au/listing/' + (financeApplicationEmail.propertyId * 12569) + '">' + financeApplicationEmail.propertyId + '</a></li>' +
                '<li>Buyer First Name:  ' + financeApplicationEmail.firstName + '</li>' +
                '<li>Buyer Last Name:  ' + financeApplicationEmail.lastName + '</li>' +
                '<li>Buyer Email:  ' + financeApplicationEmail.email+ '</li>' +
                '<li>Buyer Phone:  ' + financeApplicationEmail.phone + '</li>' +
                '<li>Buyer Postcode:  ' + financeApplicationEmail.postcode + '</li>' + 
                '<li>Buyer Suburb:  ' + financeApplicationEmail.suburb + '</li>' + 
                '<li>Buyer Request For: ' + financeApplicationEmail.requestTypes.join(",") + '</li>' +
                '</ul>';
            return CommonService.emailTemplateSimple(bodyHTML);
        }

        service.sendEnquiry = function(enquiry, property) {
          var toEmail = property.listingAgent[0][0].email;
          var toEmailLeader = property.agency[0].info.email;
          enquiry.propertyId = property.propertyId;
          // var toEmail = ['anjanshakya@wiseberry.com.au'];
          var toEmail = [toEmail, toEmailLeader, 'developer@wiseberry.com.au'];
          var emailDetails = {
            toEmail: toEmail,
            sourceEmail: 'no-reply@wiseberry.com.au',
            htmlBody: getEnquiryEmailBody(enquiry),
            txtBody: getEnquiryEmailBody(enquiry),
            subject: 'Buyer Enquiry',
            replyToAddress: 'no-reply@wiseberry.com.au'
          };
          return CommonService.sendEmail(emailDetails);
        }


        var getEnquiryEmailBody = function(enquiry) {
            var bodyHTML = '<p>Hi,</p>' +
                '<p>There is a new  enquiry from buyer: ' + enquiry.name + '</p>'  + 
                '<br>' +
                '<hr>' +
                '<p>Details:</p>'+
                '<ul>' +
                '<li>Property:<a href="http://www.wiseberry.com.au/listing/' + (enquiry.propertyId * 12569) + '">' + enquiry.propertyId + '</a></li>' +
                '<li>Buyer Name:  ' + enquiry.name + '</li>' +
                '<li>Buyer Email:  ' + enquiry.email+ '</li>' +
                '<li>Buyer Phone:  ' + enquiry.phone + '</li>' +
                '<li>About Buyer:  ' + enquiry.aboutBuyer + '</li>' + 
                '<li>Buyer would like to:  ' + enquiry.buyerLikes.join(",") + '</li>' +
                '</ul>';
            return CommonService.emailTemplateSimple(bodyHTML);
        }

         service.getListingSeen = function() {
            fnRefreshVars();
            var dfd = $q.defer();
            $http({
                url: appInfo.endpoint+'buyers/listingseen.json', 
                method: "GET",
                params: {usercode: usercode, api_key: appInfo.key },
                transformResponse: function (data, headers) {
                
                  var listingSeen = JSON.parse(data);
                  angular.forEach(listingSeen, function(rs){
                    rs.property = rs.property[0];
                    var prop = rs.property;

                    //filter out past open homes
                    if(prop.openHome && prop.openHome.length >0) {
                      var futureOpenHomes = [];
                      var openHomes = prop.openHome[0];
                      var currentDate = parseInt(new Date().getTime()/1000);
                      angular.forEach(openHomes, function(openHome){
                          if( parseInt(openHome.starts) > currentDate) {
                            futureOpenHomes.push(openHome);  
                          }
                      });
                      prop.openHome[0] = futureOpenHomes;
                    }
                    
                    prop.propertyRef = prop.propertyId*12569;
                    prop.bed = 0;
                    prop.bath = 0;
                    prop.parking =0;

                    angular.forEach(prop.propertyComponents[0], function(comp) {
                      if(comp.name=="Bedroom") {
                        prop.bed = parseInt(comp.qty);
                      } else if(comp.name=="Bathroom") {
                        prop.bath= parseInt(comp.qty);
                      } else if(comp.name=="Parking"){
                        prop.parking= parseInt(comp.qty);
                      }
                    });

                  });
                  return listingSeen;
                },
            }).success(function (data, status, headers, config){
                dfd.resolve(data);
            }).error(function(data, status, headers, config) {
                dfd.reject("Error: Unable to update. Status = " + status); 
            });
            return dfd.promise;   
        }

        service.getBuyerPropertyRequestPreferences = function() {
           fnRefreshVars();
           var dfd = $q.defer();
           if($rootScope.buyerPropertyRequestPreferences) {
              dfd.resolve($rootScope.buyerPropertyRequestPreferences);
           } else {
            $http({
                url: appInfo.endpoint+'buyers/buyerpropetyrequestpreferences.json', 
                method: "GET",
                params: {usercode: usercode, api_key: appInfo.key, buyerContactId: currentUser.id},
            }).success(function (data, status, headers, config){

               var  preferences = {
                  priceFrom: "",
                  priceTo: "",
                  bed: "0",
                  bath: "0",
                  parking: "0",
                  pool: "",
                  suburbs: [],
                  propertyTypes: []
               };

               preferences.priceFrom = data[0].priceFrom;
               preferences.priceTo = data[0].priceTo;

               angular.forEach(data[0].components, function(component){
                  if(component.name == 'Bedroom') {
                      preferences.bed = parseInt(component.min).toString();
                  }
                  if(component.name == 'Bathroom') {
                      preferences.bath = parseInt(component.min).toString();
                  }
                  if(component.name == 'Parking') {
                      preferences.parking = parseInt(component.min).toString();
                  }
                  if(component.name == 'Pool' && parseInt(component.min>0)) {
                      preferences.pool = 'Yes';
                  }
               });

               angular.forEach(data[0].propertyTypes, function(propertyType){
                  preferences.propertyTypes.push(propertyType.tag);
               });

               angular.forEach(data[0].suburbs, function(suburb){
                  preferences.suburbs.push({ id: suburb.location, category: suburb.category, name: suburb.name });
               });

               $rootScope.buyerPropertyRequestPreferences = preferences;
               dfd.resolve(preferences);
            }).error(function(data, status, headers, config) {
                dfd.reject("Error: Unable to update. Status = " + status); 
            });
           }
           return dfd.promise;  
        }

        service.registerForOpenHome = function(registration, openHome, property) {
          var toEmail = property.listingAgent[0][0].email;
          var toEmailLeader = property.agency[0].info.email;
          registration.propertyId = property.propertyId;
          // var toEmail = ['anjanshakya@wiseberry.com.au'];
          // var toEmail = [toEmail, toEmailLeader];
          var toEmail = [toEmail, toEmailLeader, 'developer@wiseberry.com.au'];
          var emailDetails = {
            toEmail: toEmail,
            sourceEmail: 'no-reply@wiseberry.com.au',
            htmlBody: getOpenHomeRegistrationEmailBody(registration, openHome, property),
            txtBody: getOpenHomeRegistrationEmailBody(registration, openHome, property),
            subject: 'Open home registration',
            replyToAddress: 'no-reply@wiseberry.com.au'
          };
          return CommonService.sendEmail(emailDetails);
        }


        var getOpenHomeRegistrationEmailBody = function(registration, openHome, property) {

            var openHomeDate = $filter('date')(openHome.starts*1000, 'EEE d MMM yyyy, h:mm a');
            var bodyHTML = '<p>Hi,</p>' +
                '<p>A buyer has registered for open home: ' + registration.name + '</p>'  + 
                '<br>' +
                '<hr>' +
                '<p>Details:</p>'+
                '<ul>' +
                '<li>Open Home Date: ' + openHomeDate + '</li>' +
                '<li>Property Suburb: ' + property.locationName + '</li>' +
                '<li>Property Address: <a href="http://www.wiseberry.com.au/listing/' + (registration.propertyId * 12569) + '">'  + 
                   property.streetUnit + ' ' + 
                   property.streetRef + ' ' + 
                   property.streetName + ' ' + 
                   property.streetType 
                 + '</a></li>' +
                '<li>Property Price Range: ' + '$'+ property.valuationFrom + ' - $' + property.valuationTo + '</li>' +
                '<li>Buyer Name:  ' + registration.name + '</li>' +
                '<li>Buyer Email:  ' + registration.email+ '</li>' +
                '<li>Buyer Phone:  ' + registration.phone + '</li>' +
                '</ul>';
            return CommonService.emailTemplateSimple(bodyHTML);
        }

        service.addPreferenceChangeNote = function(newPreferences, oldPreferences) {

          var dfd = $q.defer();
          var arrChanged = [];

          if(newPreferences.priceFrom.trim() !=  oldPreferences.priceFrom.trim()) {
            arrChanged.push("Price from changed from " + oldPreferences.priceFrom.trim() + ' to ' + newPreferences.priceFrom.trim());
          }

          if(newPreferences.priceTo.trim() !=  oldPreferences.priceTo.trim()) {
            arrChanged.push("Price to changed from " + oldPreferences.priceTo.trim() + ' to ' + newPreferences.priceTo.trim());
          }

          if(newPreferences.bed.trim() !=  oldPreferences.bed.trim()) {
            arrChanged.push("Bed changed from " + oldPreferences.bed.trim() + ' to ' + newPreferences.bed.trim());
          }

          if(newPreferences.bath.trim() !=  oldPreferences.bath.trim()) {
            arrChanged.push("Bath changed from " + oldPreferences.bath.trim() + ' to ' + newPreferences.bath.trim());
          }

          if(newPreferences.parking.trim() !=  oldPreferences.parking.trim()) {
            arrChanged.push("Parking changed from " + oldPreferences.parking.trim() + ' to ' + newPreferences.parking.trim());
          }

          if(newPreferences.pool.trim() !=  oldPreferences.pool.trim()) {
            arrChanged.push("Pool changed from " + oldPreferences.pool.trim() + ' to ' + newPreferences.pool.trim());
          }

          //check if suburbs are changed
          $blnSuburbChanged = (newPreferences.suburbs.length != oldPreferences.suburbs.length);
          
          if (!$blnSuburbChanged) {
            for (var i=0; i < newPreferences.suburbs.length; i++) {
              $blnSuburbChanged = true;
              for (var j=0; j < oldPreferences.suburbs.length; j++) {
                if(newPreferences.suburbs[i].id == oldPreferences.suburbs[j].id) {
                  $blnSuburbChanged = false;
                  break;
                }   
              }
              if($blnSuburbChanged) {
                break;
              }
            }
          }

          if($blnSuburbChanged) {
            var oldSuburbs = [];
            var newSuburbs = [];

            for (var i=0; i < newPreferences.suburbs.length; i++) {
                newSuburbs.push(newPreferences.suburbs[i].name);
            }

            for (var j=0; j < oldPreferences.suburbs.length; j++) {
                oldSuburbs.push(oldPreferences.suburbs[j].name);
            }
            oldSuburbs = oldSuburbs.join(',');
            newSuburbs = newSuburbs.join(',');
            arrChanged.push('Suburbs changed from '  + oldSuburbs + ' to ' + newSuburbs);
          }


          //check if property types are changed
          $blnPropertyTypes = (newPreferences.propertyTypes.length != oldPreferences.propertyTypes.length);
          
          if (!$blnPropertyTypes) {
            for (var i=0; i < newPreferences.propertyTypes.length; i++) {
              $blnPropertyTypes = true;
              for (var j=0; j < oldPreferences.propertyTypes.length; j++) {
                if(newPreferences.propertyTypes[i] == oldPreferences.propertyTypes[j]) {
                  $blnPropertyTypes = false;
                  break;
                }   
              }
              if($blnPropertyTypes) {
                break;
              }
            }
          }

          if($blnPropertyTypes) {
            var propertyTypes = service.getPropertyTypes(); 
            var oldPropertyTypes = [];
            var newPropertyTypes = [];

            for (var i=0; i < newPreferences.propertyTypes.length; i++) {
                var index = CommonService.indexById(propertyTypes, newPreferences.propertyTypes[i])
                newPropertyTypes.push(propertyTypes[index].name);
            }

            for (var j=0; j < oldPreferences.propertyTypes.length; j++) {
                var index = CommonService.indexById(propertyTypes, oldPreferences.propertyTypes[i])
                oldPropertyTypes.push(propertyTypes[index].name);
            }
            oldPropertyTypes = oldPropertyTypes.join(',');
            newPropertyTypes = newPropertyTypes.join(',');
            arrChanged.push('Property types changed from '  + oldPropertyTypes + ' to ' + newPropertyTypes);
          }

          if(arrChanged.length > 0) {
            var noteText = "Made changes to preferences: ";
            noteText += arrChanged.join(' ');  
            return service.addNote(noteText)
          } else {
             dfd.resolve({});
          }
          return dfd.promise;

        }

        service.addNote = function(noteText) {
           var dfd = $q.defer();
           fnRefreshVars();
           var params = {};
            params.usercode = currentUser.authdata;
            params.contactId = currentUser.id;
            params.detail = noteText;
           $http({
                url: appInfo.endpoint+'buyers/addNote.json', 
                method: "POST",
                params: { api_key: appInfo.key },
                data: params
            }).success(function(data) {
                dfd.resolve(data);
            }).error(function(data, status, headers, config) {
                dfd.reject("Error: request returned status " + status); 
            });
            return dfd.promise;
        }


         service.getWatchlistNotificationCount = function () {
            fnRefreshVars();
            var lastLogInDate = localstorage.get('lastLogInDate');
            if (!lastLogInDate || lastLogInDate == "null") {
              lastLogInDate = 0;
            }
            var dfd = $q.defer();
            $http({
                url: appInfo.endpoint+'buyers/propertywatchlistnotificationcount.json', 
                method: "GET",
                params: {usercode: usercode, api_key: appInfo.key, buyerContactId: currentUser.id, lastLogInDate: lastLogInDate},
            }).success(function (data, status, headers, config){
                dfd.resolve(data);
            }).error(function(data, status, headers, config) {
                dfd.reject("Error: Unable to update. Status = " + status); 
            });

            return dfd.promise;   
        };


         service.chagnePassword = function (buyerSettings) {
            fnRefreshVars();
            // var dataParams = {
            //   contactId: currentUser.id,
            //   email: buyerSettings.email,
            //   mobile: buyerSettings.mobile,
            //   password: buyerSettings.password,
            //   usercode: usercode
            // };
            var dataParams = {
              password: buyerSettings.password,
              usercode: usercode
            };
            var dfd = $q.defer();
            $http({
                url: appInfo.endpoint+'buyers/updateInfo.json', 
                method: "POST",
                params: {api_key: appInfo.key},
                data: dataParams
            }).success(function (data, status, headers, config){
                dfd.resolve(data);
            }).error(function(data, status, headers, config) {
                dfd.reject("Error: Unable to update. Status = " + status); 
            });

            return dfd.promise; 
        };

        service.getServices = function() {
            fnRefreshVars();
            var dfd = $q.defer();
            $http({
                url: appInfo.endpoint+'buyers/services.json', 
                method: "GET",
                params: {usercode: usercode, api_key: appInfo.key, organisationId: activeAgency.id},
            }).success(function (data, status, headers, config){
                dfd.resolve(data);
            }).error(function(data, status, headers, config) {
                dfd.reject("Error: Unable to update. Status = " + status); 
            });

            return dfd.promise;   
        }

        service.sendSellEnquiry = function(enquiry) {
          fnRefreshVars();
          var toEmail = activeAgency.orgEmail;
          var toEmail = [toEmail, 'developer@wiseberry.com.au'];
          // var toEmail = ['anjanshakya@wiseberry.com.au'];
          var emailDetails = {
            toEmail: toEmail,
            sourceEmail: 'no-reply@wiseberry.com.au',
            htmlBody: getSellEnquiryEmailBody(enquiry),
            txtBody: getSellEnquiryEmailBody(enquiry),
            subject: 'Buyer Selling Enquiry',
            replyToAddress: 'no-reply@wiseberry.com.au'
          };
          return CommonService.sendEmail(emailDetails);
        }


        var getSellEnquiryEmailBody = function(enquiry) {
            var bodyHTML = '<p>Hi,</p>' +
                '<p>There is a new enquiry from buyer about selling: </p>'  + 
                '<br>' +
                '<hr>' +
                '<p>Details:</p>'+
                '<ul>' +
                '<li>Buyer Name:  ' + enquiry.name + '</li>' +
                '<li>Buyer Email:  ' + enquiry.email+ '</li>' +
                '<li>Buyer Phone:  ' + enquiry.phone + '</li>' +
                '</ul>';
            return CommonService.emailTemplateSimple(bodyHTML);
        }



        service.getFinanceInfo = function() {
          var dfd = $q.defer();
          if($rootScope.financeInfo) {
            dfd.resolve($rootScope.financeInfo);
          } else {
            $http({
               url: 'config.json', 
               method: "GET",
            }).success(function (data, status, headers, config){
               $rootScope.financeInfo = data;
               dfd.resolve(data);
            }).error(function(data, status, headers, config) {
               dfd.reject("Error: Unable to update. Status = " + status); 
            });
          }
          return dfd.promise; 
        }

         // Add new or Update to do item
        service.getPropertyMicrositeURL = function(arrPropetyRefs) {
            fnRefreshVars();
            var dataParams = {
              propertyRefs: arrPropetyRefs,
              usercode: usercode
            };
            var dfd = $q.defer();
            $http({
                url: appInfo.endpoint + 'listing/micrositeurl.json', 
                method: "POST",
                params: {api_key: appInfo.key},
                data: dataParams
            }).success(function(data) {
                dfd.resolve(data);
            }).error(function(data, status, headers, config) {
                dfd.reject("Error: request returned status " + status); 
            });
            return dfd.promise;
        };

        return service;
    }]);